export default __webpack_public_path__ + "static/media/7eaaebe3.svg";